import { Box, Icon, Card } from 'vopay';
import { usePaylink } from '@/providers/Paylink.provider';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';
import styles from './RequestEndedPage.module.scss';

export default function RequestEndedPage() {
  const { paylink, paylinkSuccess } = usePaylink();
  const { t } = useTranslation('translations', { keyPrefix: 'Error' });

  const status = !paylinkSuccess ? 'expired' : paylink.Status;
  const senderName = paylink.SenderName;
  const statusContent: Partial<Record<string, { title: string; message: string }>> = {
    expired: {
      title: t('expiredTitle', { defaultValue: 'Request Expired' }),
      message: t('expiredMessage', {
        defaultValue: 'This link is no longer available. Request the sender for a new link.',
      }),
    },
    cancelled: {
      title: t('cancelledTitle', { defaultValue: 'Request Cancelled' }),
      message: t('cancelledMessage', {
        defaultValue: 'The sender cancelled this request. The link is no longer available.',
      }),
    },
    declined: {
      title: t('declinedTitle', { defaultValue: 'Request Declined' }),
      message: t('declinedMessage', {
        senderName,
        defaultValue: `You have declined this request from {{senderName}}. If this was a mistake or you need assistance, please contact support.`,
      }),
    },
  };

  const content = statusContent[status];

  if (!content) return null;

  return (
    <div className={styles.errorMsgContainer}>
      <Card className={styles.card}>
        <Box flx="col" gapSize="16px" ai="center">
          <div className={styles.icon}>
            <Icon icon="errorRed2" width="62px" height="62px" color="none" />
          </div>
          <Box flx="col" ai="center" gapSize="4px">
            <Title level="3">{content.title}</Title>
            <div className={styles.cardMessage}>{content.message}</div>
          </Box>
        </Box>
      </Card>
    </div>
  );
}
